import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progress", "progressCircle"]
  static values = { totalItems: Number, checkedItems: Number }

  connect() {
    this.updateCounts()
  }

  updateCounts() {
    const checkboxes = this.element.querySelectorAll("input[type='checkbox'][data-item-id]")
    this.totalItemsValue = checkboxes.length
    this.checkedItemsValue = Array.from(checkboxes).filter(cb => cb.checked).length
  }

  toggle(event) {
    const checkbox = event.target
    const itemId = checkbox.dataset.itemId
    const itemRow = checkbox.closest(".grocery-item")
    const contentDiv = itemRow.querySelector(".flex-1")
    const isChecked = checkbox.checked

    if (isChecked) {
      contentDiv.classList.add("opacity-50", "line-through")
      this.checkedItemsValue++
    } else {
      contentDiv.classList.remove("opacity-50", "line-through")
      this.checkedItemsValue--
    }
    this.updateProgressDisplay()

    fetch(`/grocery_items/${itemId}/toggle`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    }).catch(() => {
      checkbox.checked = !isChecked
      if (isChecked) {
        contentDiv.classList.remove("opacity-50", "line-through")
        this.checkedItemsValue--
      } else {
        contentDiv.classList.add("opacity-50", "line-through")
        this.checkedItemsValue++
      }
      this.updateProgressDisplay()
    })
  }

  updateProgressDisplay() {
    const progress = this.totalItemsValue > 0
      ? Math.round((this.checkedItemsValue / this.totalItemsValue) * 100)
      : 0

    if (this.hasProgressTarget) {
      this.progressTarget.textContent = `${progress}%`
    }

    if (this.hasProgressCircleTarget) {
      this.progressCircleTarget.setAttribute("stroke-dasharray", `${progress} ${100 - progress}`)
    }
  }
}
